<template>
	<div class="div-box1" :style="{flex: flex}">
		<div class="box1-title flex">
			<div class="tit-text" :style="{width: width ? `${width}px` : 'auto'}">{{ title }}</div>
		</div>
		<div style="flex: 1">
        	<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				options: {},
			};
		},
		components: {

		},
		props: {
			title: {
				type: String,
				default: () => ({})
			},
			width: {
				type: [Number, String],
				default: '260'
			},
			flex: {
				type: Number,
				default: 1
			}
		},
		watch: {

		},
	}
</script>
<style lang="scss">
.div-box1 {
    width: 100%;
    height: 100%;
    position: relative;
	display: flex;
	flex-direction: column;
	.box1-title {
		border-bottom: 1px solid #09625F;
		.tit-text {
			background: url(~@/assets/images/comm/1.png) top right no-repeat;
			background-size: auto 100%;
			height: 30px;
			position: relative;
			padding: 0 25px;
			display: flex;
			align-items: center;
			&::before {
				position: absolute;
				content: '';
				height: 100%;
				width: 3px;
				background-color: #000;
				left: 10px;
			}
			// &::after {
			// 	position: absolute;
			// 	content: '';
			// 	height: 100%;
			// 	width: 15px;
			// 	background: url(~@/assets/images/comm/1.png) no-repeat;
			// 	background-size: 100% 100%;
			// 	top: 0;
			// 	right: -15px;
			// }
		}
	}
}
</style>